<mat-form-field class="chip-list">
    <mat-chip-list #chipList aria-label="Item selection">
<!--        <mat-chip *ngFor="let item of Value.value"-->
<!--                  [Selectable]="Selectable"-->
<!--                  [Removable]="Removable" (removed)="remove(item)"-->
<!--                  [Color]="Color"-->
<!--                  class="chip"-->

<!--        >-->

<!--            {{item}}-->
<!--            <mat-icon matChipRemove *ngIf="Removable">x</mat-icon>-->
<!--        </mat-chip>-->
        <div *ngIf="InputEnabled">
        <input [placeholder]="Placeholder"
               [matChipInputFor]="chipList"
               [matChipInputSeparatorKeyCodes]="SeparatorKeysCodes"
               [matChipInputAddOnBlur]="AddOnBlur"
               (matChipInputTokenEnd)="add($event)"
               [disabled]="!InputEnabled"

        >
        </div>
    </mat-chip-list>
</mat-form-field>
